import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import { ReviewStatsPeriodicInterface } from 'interfaces/review-stats.interface';
import { CompanyInterface } from 'interfaces/company.interface';

const CompanyViewBeCareful: React.FC = (): ReactElement | null => {
    const [company, reviewStatsPeriodic] = useSelector(
        (state: { company: CompanyInterface; reviewStatsPeriodic: ReviewStatsPeriodicInterface[]; }) => [
            state.company,
            state.reviewStatsPeriodic
        ]
    );

    if (company.isCustomer) {
        return null;
    }

    const thirtyDaysStats = (reviewStatsPeriodic || []).find(item => item.period === 'thirtyDays');

    if (!thirtyDaysStats || !thirtyDaysStats.totalCount || thirtyDaysStats.negativeCount / thirtyDaysStats.totalCount < 0.25) {
        return null;
    }

    return (
        <div className="company-view__be-careful">
            <div className="container">
                Bądź czujny, co najmniej 25% spośród opinii dodanych w ciągu ostatnich 30 dni jest negatywnych.
            </div>
        </div>
    );
};

export default CompanyViewBeCareful;
